module.exports = {
  language: '언어',
  selectLanguage: '언어 선택',
  charging: '충전 중',
  notCharging: '충전 안 함',
  advanceSetting: '고급 설정',
  chargingDesc: '배터리 레벨이 다음보다 낮을 때 충전 시작 ',
  enabled: '활성화됨',
  disabled: '비활성화됨',
  onPowerRestore: '전원 복원 시',
  powerWakeDesc: '** Pi와 PiSugar를 각각 독립적인 USB 충전기로 충전하고 PiSugar의 전원 스위치를 켜두세요. 외부 전원이 복원되면 자동으로 켜집니다.',
  powerWakeDescFor3: 'PiSugar는 외부 전원이 복원되면 자동으로 켜집니다.',
  powerWakeOffWarning: '전원 복원 시 깨우기 기능을 끄셨습니다. 라즈베리 파이에 별도로 외부 전원을 공급하지 마세요.',
  powerWakeOffTitle: '참고',
  confirmButtonText: '확인',
  wakeUpFeature: '예약 깨우기',
  repeat: '반복',
  repeatEveryday: '매일 반복',
  repeatOn: '다음 날짜에 반복',
  checkAll: '모두 선택',
  clearAll: '모두 해제',
  wakeUpDesc: '다음 시간에 깨우기 예약',
  wakeUpOffDesc: '깨우기 예약 해제',
  buttonFunction: '사용자 정의 버튼 기능',
  singleTapLabel: '한 번 누르기',
  doubleTapLabel: '두 번 누르기',
  longTapLabel: '길게 누르기',
  singleTap: '한 번 누르기',
  doubleTap: '두 번 누르기',
  longTap: '길게 누르기',
  none: '없음',
  edit: '편집',
  customShell: '사용자 정의 셸',
  shutdown: '종료',
  shellModalTitle: {
    single: '한 번 누를 때 실행할 셸',
    double: '두 번 누를 때 실행할 셸',
    long: '길게 누를 때 실행할 셸'
  },
  shell: '셸',
  shellPlaceholder: '여기에 셸 스크립트를 입력하세요...',
  cancel: '취소',
  confirm: '확인',
  triggered: '트리거됨',
  safeShutdown: '안전한 종료',
  batteryLevel: '배터리 레벨',
  immediately: '즉시',
  secondsDelay: '초 지연',
  rtcTime: 'RTC 시간',
  sysTime: '시스템 시간',
  syncTime: '시간 동기화',
  weekDay: {
    Monday: '월요일',
    Tuesday: '화요일',
    Wednesday: '수요일',
    Thursday: '목요일',
    Friday: '금요일',
    Saturday: '토요일',
    Sunday: '일요일'
  },
  weekDayShort: {
    Mon: '월',
    Tue: '화',
    Wed: '수',
    Thu: '목',
    Fri: '금',
    Sat: '토',
    Sun: '일'
  },
  batteryInputProtect: '배터리 입력 보호',
  batteryInputProtectDesc: '배터리가 60% ~ 80%에 도달하면 충전 프로세스가 중지되어 배터리 수명을 효과적으로 연장할 수 있습니다.',
  antiMistouch: '오터치 방지',
  antiMistouchDesc: '오터치 방지가 켜져 있으면 스위치를 클릭하고 유지해야 트리거됩니다.',
  softPoweroff: '소프트 종료',
  softPoweroffDesc: '스위치 버튼을 사용한 종료는 직접 전원을 끄지 않고 소프트웨어에서 종료 명령을 실행합니다.',
  softPoweroffShell: '소프트 종료 셸',
  softPoweroffShellDesc: '소프트 종료 이벤트가 트리거될 때 실행할 셸입니다.',
  changeLoginPassword: '로그인 비밀번호 변경',
  username: '사용자명',
  password: '비밀번호',
  passwordConfirm: '비밀번호를 다시 입력하세요',
  usernameCannotBeEmpty: '사용자명은 비어있을 수 없습니다',
  passwordCannotBeEmpty: '비밀번호는 비어있을 수 없습니다',
  passwordNotConsistent: '두 비밀번호 입력이 일치해야 합니다',
  usernameWithSpace: '사용자명에는 공백이 포함될 수 없습니다',
  passwordWithSpace: '비밀번호에는 공백이 포함될 수 없습니다',
  changePasswordSuccess: '수정이 완료되었습니다.',
  loginDialog: '로그인',
  login: '로그인'
}



// WEBPACK FOOTER //
// ./src/locale/ko-KR.js